import { useLocation } from "react-router-dom";
import onboard from "./../../../../../../../assets/images/logo.png"

export default function ExitSuccess() {
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const status = params.get("status") ?? "approved";
  const message = params.get("message") ?? "You have successfully completed";
  return (
    <section className="approved-screen exitSuccess">
      <div className="loader-block">
      </div>
      <div className="header__logo" >
        <img src={onboard} alt="OnboardingLogo" />
        <span>All-Aboard!</span>
      </div>
      <div className="card">
        <p>
          {
            status === "approved" ? <span className="material-symbols-outlined">check_circle</span> :
              <span className="material-symbols-outlined" style={{ color: "red" }}>cancel</span>
          }
        </p>
        <h2>Thank You!</h2>
        <p>{message}</p>
      </div>

    </section >
  )
}